import { jsxs as i, jsx as r } from "react/jsx-runtime";
import { forwardRef as u } from "react";
import { CalendarIcon as b } from "../../../icons/calendar-icon.mjs";
import { twMerge as t } from "tailwind-merge";
import { FieldLabel as x } from "../../form/field-label.mjs";
import { FieldErrorAndDescription as h } from "../../form/field-error-and-description.mjs";
const y = u(
  ({
    onClick: l,
    error: m,
    label: e,
    labelClassName: n,
    required: p,
    wrapperButtonInputClassName: a,
    buttonInputClassName: s,
    description: c,
    children: d,
    value: o
  }, f) => /* @__PURE__ */ i("div", { className: t("flex flex-col gap-1", a), children: [
    /* @__PURE__ */ r(x, { label: e, labelClassName: n, required: p }),
    /* @__PURE__ */ i("button", { onClick: l, ref: f, type: "button", className: s, children: [
      d(o),
      /* @__PURE__ */ r(
        b,
        {
          className: t(
            "fill-fill-primary group-focus:fill-brand-primary main-transition-colors ml-3 hidden h-[20px] w-[20px] sm:block",
            o ? "hidden sm:block" : "block"
          )
        }
      )
    ] }),
    /* @__PURE__ */ r(h, { error: m, description: c })
  ] })
);
y.displayName = "ButtonInput";
export {
  y as ButtonInput
};
